import { TextFieldTypes } from '@ionic/core';
import { IonInput, IonItem } from '@ionic/react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { disableSubmitOnEnter } from '../../../config/utils/formUtils';

interface Props {
  field: any;
  formik: any;
  testId?: string;
}

export const DocSimpleInput = ({ field, formik, testId = 'DocSimpleInput' }: Props) => {
  const { t } = useTranslation();

  const hasError = useMemo(
    () => formik.touched && formik?.errors?.[field.name],
    [formik.touched, field.name, formik?.errors],
  );

  const getTitle = useCallback(() => {
    const translation = t(`SALE.${field.label}`);
    if (field.required) return translation + ' *';

    return translation;
  }, [field.label, field.required]);

  return (
    <div>
      <div className="padding-b-16 padding-l-12">{getTitle()}</div>
      <div key={field?.name} className="flex-center-start-column-nowrap positionRelative width-300px">
        <IonItem
          id={field.name}
          className={`width-300px height-50px border-radius-input g-select-border cursorPointer ${hasError && 'b-field-border-error'}`}
          mode="md">
          <IonInput
            id={testId}
            className="height-48px"
            mode="md"
            type={field.type as TextFieldTypes}
            aria-label="delivery"
            name={field.name}
            placeholder={t(`SALE.${field.placeholder}`) + '...'}
            // See `CustomerSimpleInput.tsx` re: `ionInput` vs `ionChange`.
            onIonInput={formik.handleChange}
            value={formik.values?.[field.name]}
            maxlength={field?.maxLength}
            onKeyPress={disableSubmitOnEnter}
          />
        </IonItem>
      </div>
    </div>
  );
};
